import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BoltDirectivesModule } from '@nationwide-bolt/ng-directives';

import { QuotingFlowStore } from '@components/quoting-flow/services/quoting-flow.store';
import { QuotingFlowField } from '@components/quoting-flow/types/quoting-flow.types';

@Component({
  selector: 'hsc-form-field',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [ReactiveFormsModule, CommonModule, BoltDirectivesModule],
  template: `
    <div class="grid gap-2">
      @if (optional()) {
        <div class="flex items-baseline gap-1">
          <div class="font-bold">{{ label() }}</div>
          <div>&nbsp;(optional)</div>
        </div>
      } @else {
        <div class="font-bold">{{ label() }}</div>
      }

      @if (value()) {
        <div [class]="invalidClass()">
          @switch (textCase()) {
            @case ('uppercase') {
              {{ value() | uppercase }}
            }
            @case ('titlecase') {
              {{ value() | titlecase }}
            }
            @default {
              {{ value() }}
            }
          }
        </div>
      } @else {
        <ng-content />
      }
    </div>
  `,
})
export class FormField {
  private readonly qfStore = inject(QuotingFlowStore);

  label = input.required<string>();
  value = input<string | null | undefined>();
  textCase = input<'uppercase' | 'titlecase'>();
  fieldName = input<QuotingFlowField>();
  optional = input(false, { transform: booleanAttribute });

  protected readonly invalidClass = computed(() => {
    const field = this.fieldName();
    return field ? this.qfStore.isFieldInvalid(field, 'view') : null;
  });
}
